import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPersonByIdV2UseCaseInterface } from 'domain/usecases';

export class RemoteGetPersonByIdV2 implements GetPersonByIdV2UseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetPersonByIdV2UseCaseInterface.Params,
  ): Promise<GetPersonByIdV2UseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/v2/${params.id}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
